import React from 'react';
import { Image } from 'react-konva';
import { picDim, cachetree } from '../../library/constants';
import {
  isMobileTablet,
  isMobilePhone,
  shrinkDimBy,
} from '../../library/calc';

const margin = 2;

const hovering = ({callRefObj, hovering, n}) => {
  callRefObj({key: `node_n-${n}`, method: 'callHover', param: hovering});
}

export class Pic extends React.Component {

    constructor(props){
      super(props);
      this.createNewImageOnce = false;
    }


    componentDidUpdate(){
      if(this.props.zoomedFocusCompleteAfterInitialTreeLoad || this.props.isPedigree){
        if( this.shouldCreateNewImage()){
          this.createNewImageOnce = true;
          const fromWhere = 'pic component'
          this.props.createImageElementForProfilePic({nodeObj: this.props.nodeObj, fromWhere});
        }
      }

      if(cachetree){
        this.refs.imageNodeCache.cache();
      }
    }

    shouldCreateNewImage(){

      const needsImgLoad = ()=>{
        return this.props.nodeObj.img.type === 'real' &&
          typeof(this.props.nodeObj.img.image) === 'undefined';
      }

      return (
        (needsImgLoad() && !this.createNewImageOnce) ||
        (needsImgLoad() && this.props.nodeObj.img.imageReset) ||
        (needsImgLoad() && typeof(this.props.nodeObj.g) === 'undefined')
      );
    }

/*
    shouldCreateNewImage(){

      const needsImgLoad = ()=>{
        return !this.nodeHasRestrictedViews()   &&
          this.props.nodeObj.img.type === 'real' &&
          typeof(this.props.nodeObj.img.image) === 'undefined';
      }

      return (
        (needsImgLoad() && !this.createNewImageOnce) ||
        (needsImgLoad() && this.props.nodeObj.img.imageReset)
      );
    }

    nodeHasRestrictedViews(){
      return typeof(this.props.nodeObj.nvp) !== 'undefined';
    }
*/
    touchPic(){

      let {
        n,
        nodeObj,
        onClickedNode,
        userTouchedNode,
        stopStageClickPropagation,
        setNodeForFlipFocus,
        setShowMobileFlipCard,
        storePrIdToLocationHistory
      } = this.props;


      stopStageClickPropagation({fromWhere:'pic component A'});

      userTouchedNode({
        node:n,
        callback: ()=>{
          if(isMobilePhone() ){
            storePrIdToLocationHistory({userExitsFlipCard: false, prId: nodeObj.prId})
            setNodeForFlipFocus(n);
            setShowMobileFlipCard(n);
          };
          if(isMobileTablet() ) onClickedNode(n);
        },
        fromWhere:'pic'
      });
    }

    render() {

      let {
        photoBorderColor,
        n,
        left,
        top,
        onClickedNode,
        cursorBecomesMove,
        cursorBecomesPointer,
        hideMatchBubble,
        img,
        g,
        // nvp,
        pedigreeIsTall,
      } = this.props;

      left += margin;
      top += margin;

      let useThisImg = null;

      switch(g) {
        case 'm':
            useThisImg = this.props.placeholderImage_m;
            break;
        case 'f':
            useThisImg = this.props.placeholderImage_f;
            break;
        case 'u':
            useThisImg = this.props.placeholderImage_u;
            break;
        case undefined:
            useThisImg = this.props.placeholderImage_u;
            break;

        default:
      }

      // if(typeof(nvp) !== 'undefined') useThisImg = this.props.placeholderImage_u;

      let picDimPedigree = ( pedigreeIsTall ? 17 : 11);

      return (

        <Image
          ref={'imageNodeCache'}
          image={( typeof(img.image) !== 'undefined' ? img.image: useThisImg)}
          width={( this.props.isPedigree ?  picDimPedigree: picDim)}
          height={( this.props.isPedigree ?  picDimPedigree: picDim)}
          x={left}
          y={top}
          strokeWidth={1}
          stroke={photoBorderColor}

          crop={(
            typeof(img.image) !== 'undefined'

            ?

              {
                x: img.cropStartX,
                y: img.cropStartY / ( img.heightIsDoubleWidth ? img.diffPercent: 1),
                width: img.sideLength,
                height: img.sideLength
              }

            :

              {
                x: 0,
                y: 0,
                width: 160,
                height: 160
              }

            )}

          onTouchStart={()=>{
            this.touchPic();
          }}

          onMouseover={()=>{
            hideMatchBubble();
          }}

          onClick={()=>{
            if(isMobilePhone() ) return;
            onClickedNode(n);
          }}

          onMouseenter={()=>{
            hovering({callRefObj: this.props.callRefObj, hovering: true, n: this.props.n});
            cursorBecomesPointer();
          }}
          onMouseleave={()=>{
            cursorBecomesMove();
            hovering({callRefObj: this.props.callRefObj, hovering: false, n: this.props.n});
          }}

        />

      );

    }
}


export class Deadbanner extends React.Component {

  render() {

    let {
      n,
      left,
      top,
      onClickedNode,
      userTouchedNode,
      cursorBecomesMove,
      cursorBecomesPointer,
      stopStageClickPropagation,
      deadBannerImage,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      isPedigree,
      pedigreeIsTall,
      nodeObj,
      storePrIdToLocationHistory,
    } = this.props;

    if(n < 0) return null;

    left += margin;
    top += margin;

    let dim = {
      width: 10,
      height: 10,
    };

    const howmuch = ( pedigreeIsTall ? .9: .7);
    if(isPedigree) dim = shrinkDimBy({dim, howmuch})

    return (
      <Image
        image={deadBannerImage}
        x={left}
        y={top}
        width={dim.width}
        height={dim.height}


        onTouchStart={()=>{
          stopStageClickPropagation({fromWhere:'dead banner'});
          userTouchedNode({
            node:n,
            callback: ()=>{
              if(isMobilePhone() ){
                storePrIdToLocationHistory({userExitsFlipCard: false, prId: nodeObj.prId})
                setNodeForFlipFocus(n);
                setShowMobileFlipCard(n);
              }
              if(isMobileTablet() ){
                onClickedNode(n);
              }
            },
            fromWhere: 'Deadbanner'
          });
        }}


        onClick={()=>{
          if(isMobilePhone() ) return;
          onClickedNode(n);
        }}


        // onMouseenter={()=>{
        //   hovering({hovering: true, n: this.props.n});
        //   cursorBecomesPointer();
        // }}
        // onMouseleave={()=>{
        //   hovering({hovering: false, n: this.props.n});
        //   cursorBecomesMove();
        // }}


        onMouseenter={()=>{
          hovering({callRefObj: this.props.callRefObj, hovering: true, n: this.props.n});
          cursorBecomesPointer();
        }}
        onMouseleave={()=>{
          cursorBecomesMove();
          hovering({callRefObj: this.props.callRefObj, hovering: false, n: this.props.n});
        }}

      />
    )
  };
};


export class PresummedDeadBanner extends React.Component {

  render() {

    let {
      n,
      left,
      top,
      onClickedNode,
      userTouchedNode,
      cursorBecomesMove,
      cursorBecomesPointer,
      stopStageClickPropagation,
      presummedDeadBannerImage,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      isPedigree,
      pedigreeIsTall,
      nodeObj,
      storePrIdToLocationHistory,
    } = this.props;

    if(n < 0) return null;

    left += margin;
    top += margin;

    let dim = {
      width: 10,
      height: 10,
    };

    const howmuch = ( pedigreeIsTall ? .9: .7);
    if(isPedigree) dim = shrinkDimBy({dim, howmuch})

    return (
      <Image
        image={presummedDeadBannerImage}
        x={left}
        y={top}
        width={dim.width}
        height={dim.height}

        onTouchStart={()=>{
          stopStageClickPropagation({fromWhere:'presumed deadbanner '});
          userTouchedNode({
            node: n,
            callback: ()=>{
              if(isMobilePhone() ){
                storePrIdToLocationHistory({userExitsFlipCard: false, prId: nodeObj.prId})
                setNodeForFlipFocus(n);
                setShowMobileFlipCard(n);
              }
              if(isMobileTablet() ) onClickedNode(n);
            },
            fromWhere: 'PresummedDeadBanner'
          });
        }}

        onClick={()=>{
          if(isMobilePhone() ) return;
          onClickedNode(n);
        }}

        // onMouseenter={()=>{
        //   hovering({hovering: true, n: this.props.n});
        //   cursorBecomesPointer();
        // }}
        // onMouseleave={()=>{
        //   hovering({hovering: false, n: this.props.n});
        //   cursorBecomesMove();
        // }}

        onMouseenter={()=>{
          hovering({callRefObj: this.props.callRefObj, hovering: true, n: this.props.n});
          cursorBecomesPointer();
        }}
        onMouseleave={()=>{
          cursorBecomesMove();
          hovering({callRefObj: this.props.callRefObj, hovering: false, n: this.props.n});
        }}


      />
    )
  };
};
